import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  sliderContainer: {
    padding: "200px",
    backgroundColor: "#ebebeb",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "20px",
      paddingRight: "20px",
      paddingTop: "75px",
      paddingBottom: "75px"
    }
  },
  sliderStyle: {
    width: "980px",
    "& .slick-custom-left": {
      left: "-40px"
    },
    "& .slick-custom-rigth": {
      right: "-40px"
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      "& .slick-custom-left": {
        left: "-28px"
      },
      "& .slick-custom-rigth": {
        right: "-28px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      "& .slick-custom-left": {
        left: "-18px"
      },
      "& .slick-custom-rigth": {
        right: "-18px"
      }
    }
  }
}));

export default styles;
